import { FonotekaScope } from '@/features/fonoteka/FonotekaScope';
import { FonotekaCatalog } from '@/features/fonoteka/FonotekaCatalog';

export function FonotekaPage() {
  return (
    <FonotekaScope>
      <div className="fonoteka-stage">
        <FonotekaCatalog />
      </div>
    </FonotekaScope>
  );
}
